<app-toolbar [token]="token" [breadcrumbs]="breadcrumbs" [ProcedureValue]="ProcedureValue"></app-toolbar>
<div class="main-content">
  <div class="row">
    <div class="col xl8 l8 m12 s12">
      <video
        class="video-js vjs-big-play-centered pgg-video vjs-16-9"
        controls
        playsinline
        preload="auto" #idVideo>
        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to a
          web browser that
          <a href="https://videojs.com/html5-video-support/" target="_blank">
            supports HTML5 video
          </a>
        </p>
      </video>
    </div>
    <div class="col xl4 l4 m12 s12" *ngIf="!isLoading">
      <form [formGroup]="formCreate" (submit)="showModalEditConfirm()">
        <div class="row">

          <br> <strong>Información del proceso:</strong>
          {{videoEdit.JuzgadoProcesoCod+videoEdit.YearRadicado+videoEdit.NumeroProceso+videoEdit.Consecutivo}}
          <br>

          <div *ngIf="!isStream">

            <div class="col s6 m4 l6">
              <mat-form-field class="example-full-width" appearance="standard">
                <mat-label>Juzgado</mat-label>
                <input matInput
                       matTooltip="Juzgado"
                       (keypress)="onlyNumberKey($event)"
                       formControlName="JuzgadoProcesoCod"
                       required [(ngModel)]="videoEdit.JuzgadoProcesoCod"
                       (ngModelChange)="checkLength($event,'JuzgadoProcesoCod',12)">
              </mat-form-field>
            </div>

            <div class="col s6 m3 l6">
              <mat-form-field class="example-full-width" appearance="standard">
                <mat-label>Año Radicado</mat-label>
                <input matInput type="number"
                        matTooltip="Año Radicado"
                        formControlName="YearRadicado"
                        required [(ngModel)]="videoEdit.YearRadicado"
                        (ngModelChange)="onYearRadicadoChange($event)">
              </mat-form-field>
            </div>

            <div class="col s6 m3 l6">
              <mat-form-field class="example-full-width" appearance="standard">
                <mat-label>Numero Proceso</mat-label>
                <input matInput
                       matTooltip="Numero Proceso"
                       (keypress)="onlyNumberKey($event)"
                       formControlName="NumeroProceso"
                       required [(ngModel)]="videoEdit.NumeroProceso"
                       (ngModelChange)="checkLength($event,'NumeroProceso',5)">
              </mat-form-field>
            </div>

            <div class="col s6 m2 l6">
              <mat-form-field class="example-full-width" appearance="standard">
                <mat-label>Consecutivo</mat-label>
                <input matInput
                        matTooltip="Consecutivo"
                        (keypress)="onlyNumberKey($event)"
                       (ngModelChange)="checkLength($event,'Consecutivo',2)"
                       formControlName="Consecutivo"
                       required [(ngModel)]="videoEdit.Consecutivo"
                       (ngModelChange)="checkLength($event,'Consecutivo',2)">
              </mat-form-field>
            </div>

          </div>

          <div *ngIf="isStream">
            <div class="col s12">
              <mat-form-field class="example-full-width" appearance="standard">
                <mat-label>Número de proceso / Nombre Evento o Video Conferencia:</mat-label>
                <input matInput
                       matTooltip="Juzgado"
                       formControlName="JuzgadoProcesoCod"
                       required [(ngModel)]="videoEdit.JuzgadoProcesoCod"
                       (ngModelChange)="checkLength($event,'JuzgadoProcesoCod',50)">
              </mat-form-field>
            </div>
          </div>

          <br> <strong>Juez:</strong>
          <div class="col s12">
            <mat-form-field class="example-full-width" appearance="standard">
              <mat-label>Juez</mat-label>
              <input matInput
                     matTooltip="Juez"
                     formControlName="Juez"
                     (keypress)="onlyAlphabeticalKey($event)"
                     required [(ngModel)]="videoEdit.Juez">
            </mat-form-field>
          </div>

          <br> <strong>Información de la audiencia:</strong>
          {{videoEdit.TipoAudiencia+videoEdit.JuzgadoCod+videoEdit.NombreSala}}
          <br>

          <div class="col s6 m4 l6">
            <mat-form-field class="example-full-width" appearance="standard">
              <mat-label>Tipo Audiencia</mat-label>
              <mat-select formControlName="TipoAudiencia" [value]="videoEdit.TipoAudiencia"
                          matTooltip="Tipo Audiencia"
                          required [(ngModel)]="videoEdit.TipoAudiencia">
                <mat-option *ngFor="let tipo of TIPOSAUDIENCIA" [value]="tipo">
                  {{tipo}}
                </mat-option>
              </mat-select>

            </mat-form-field>
          </div>

          <div class="col s6 m4 l6">
            <mat-form-field class="example-full-width" appearance="standard">
              <mat-label>Juzgado</mat-label>
              <input matInput
                     matTooltip="Juzgado"
                     (keypress)="onlyNumberKey($event)"
                     formControlName="JuzgadoCod"
                     required [(ngModel)]="videoEdit.JuzgadoCod"
                     (ngModelChange)="checkLength($event,'JuzgadoCod',12)">
            </mat-form-field>
          </div>

          <div class="col s12 m4 l12">
            <mat-form-field class="example-full-width" appearance="standard">
              <mat-label>Nombre Sala</mat-label>
              <input matInput
                     matTooltip="Nombre Sala"
                     formControlName="NombreSala"
                     (keypress)="onlyAlphanumericKey($event)"
                     required [(ngModel)]="videoEdit.NombreSala"
                     (ngModelChange)="checkLength($event,'NombreSala',10)">
            </mat-form-field>
          </div>

          <br> <strong>Información de la grabación:</strong>
          {{videoEdit.NumeroGrabacion+"_"+reverseFormDate(videoEdit.FechaGrabacion)+"_"+reverseHour(videoEdit.HoraGrabacion)+"_"+videoEdit.OrigenGrabacion}}
          <br>

          <div class="col s12 m3 l12">
            <mat-form-field class="example-full-width" appearance="standard">
              <mat-label>Número Grabación</mat-label>
              <input matInput
                     matTooltip="Número Grabación"
                     (keypress)="onlyNumberKey($event)"
                     formControlName="NumeroGrabacion"
                     required [(ngModel)]="videoEdit.NumeroGrabacion"
                     (ngModelChange)="checkLength($event,'NumeroGrabacion',2)">
            </mat-form-field>
          </div>

          <div class="col s6 m3 l6">
            <mat-form-field class="example-full-width" appearance="standard">
              <mat-label>Fecha Grabación</mat-label>
              <input matInput type="date"
                     matTooltip="Fecha Grabación"
                     formControlName="FechaGrabacion"
                     required [(ngModel)]="videoEdit.FechaGrabacion"
                     max="{{date | date:'yyyy-MM-dd'}}">
            </mat-form-field>
          </div>

          <div class="col s6 m3 l6">
            <mat-form-field class="example-full-width" appearance="standard">
              <mat-label>Hora Grabación</mat-label>
              <input matInput type="time"
                     matTooltip="Hora Grabación"
                     formControlName="HoraGrabacion"
                     required [(ngModel)]="videoEdit.HoraGrabacion">
            </mat-form-field>
          </div>

          <div class="col s12 m3 l12">
            <mat-form-field class="example-full-width" appearance="standard">
              <mat-label>Origen Grabación</mat-label>
              <mat-select formControlName="OrigenGrabacion" [value]="videoEdit.OrigenGrabacion"
                      matTooltip="Origen Grabación"
                      required [(ngModel)]="videoEdit.OrigenGrabacion">
                <mat-option *ngFor="let tipo of ORIGENESGRABACION" [value]="tipo">
                  {{tipo}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col s12 m6 l12 xl12">
            <button mat-button mat-flat-button
                    [disabled]="formCreate.invalid || areChanges()"
                    class="aling-checkbox-button background-color-buttom updateButton">
              <mat-icon>update</mat-icon> Actualizar
            </button>
          </div>

        </div>
      </form>
    </div>

  </div>
</div>

<app-footer></app-footer>
